import { HierarchicalGroup } from "@/types/generated/ExperienceMasterDataApi";

export function mapHierarchicalGroupsToMap(groups: HierarchicalGroup[]): Map<string, HierarchicalGroup> {
  const groupMap = new Map<string, HierarchicalGroup>();
  for (const group of groups) {
    groupMap.set(group.code, group);
  }
  return groupMap;
}
